import React, { useMemo } from "react"
import styles from "./styles"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { Box, Typography, Button, Divider } from "@material-ui/core"
import AddIcon from "@material-ui/icons/Add"
import { isEmpty } from "lodash"
import formatNumberWithCommas from "../../../../utils/formatNumberWithCommas"

import { toggleAddDiscountDialog } from "../../../../actions/billingDialogs"
import { openSnackBar } from "../../../../actions/snack-bar"
import { updateGeneralDataProperties } from "../../../../actions/billing"
import { updateSolo } from "../../../../actions/solos"

const ExpenseTableTotal = ({
  data = {},
  combined = false, // only passed as true when additional & regular exp to be combined - ex: Bill Approval Admin
  addDiscount = false, // only passed on admin pages - not on client
  discount = 0,
  soloData = {}, //only comes in on Solo
  setSoloData = () => {}, //only comes in on Solo
  client = false,
}) => {
  const classes = styles()
  const dispatch = useDispatch()
  const generalData = useSelector(state => state.billing.generalData)

  const shootId = generalData && generalData.id
  const soloType = soloData && soloData.estimate_id ? "estimate" : "invoice"
  const soloId = soloData && soloData[`${soloType}_id`]

  const isDisabled = useMemo(
    () => {
      let disabled
      if (window.location.pathname.includes("solo")) {
        // Disabled for solos
        // if solo invoice, disable if full paid; if solo estimate disable if linked to shoot
        let type = soloData && soloData.estimate_id ? "estimate" : "invoice"
        disabled =
          type === "invoice"
            ? soloData && soloData.full_paid
            : soloData && (soloData.shoot_id || soloData.shoot_name)
      } else {
        disabled =
          Boolean(generalData.second_paid) || Boolean(generalData.full_paid)
      }
      return disabled
    },
    [soloData, generalData]
  )

  // *** DISCOUNT ***
  // if solo, makes call in If
  // else makes call for regular shoot
  const handleAddDiscount = dialogData => {
    let request = {
      discount: Number(dialogData.discount),
    }
    if (window.location.pathname.includes("solo")) {
      dispatch(updateSolo(soloType, soloId, request))
        .then(() => {
          setSoloData({ ...soloData, discount: request.discount })
          dispatch(
            openSnackBar({
              message: `Discount of $${
                request.discount
              } added to this ${soloType}`,
            })
          )
        })
        .catch(err => {
          console.log(err)
          openSnackBar({
            message: `Error adding discount`,
          })
        })
    } else {
      dispatch(updateGeneralDataProperties(request, shootId))
        .then(() => {
          dispatch(
            openSnackBar({
              message: `Added $${dialogData.discount} Discount`,
            })
          )
        })
        .catch(err => {
          console.log(err)
          dispatch(
            openSnackBar({ message: `Error adding discount to this shoot` })
          )
        })
    }
  }

  const handleCreateDiscount = () => {
    const dialogObject = {
      total: data.original,
      totalMinusPaid: data.original - data.paid,
      discount: discount,
      addDiscountFunc: handleAddDiscount,
      funcArgs: [],
    }
    dispatch(toggleAddDiscountDialog(true, dialogObject))
  }
  // *** DICOUNT END ***

  if (isEmpty(data)) {
    return null
  }

  return (
    <Box style={{ marginRight: "20px" }}>
      <Box className={classes.totalBox}>
        <Typography className={classes.blueTitles}>TOTAL</Typography>
        {/* <InfoIcon
          style={{ color: "#000000", opacity: "0.3", fontSize: "14px" }}
        /> */}
      </Box>
      <Box
        className={classes.totalNumberBox}
        style={{ textAlign: "right", fontSize: "1rem" }}
      >
        $
        {combined
          ? formatNumberWithCommas(data.original + data.additional)
          : formatNumberWithCommas(data.original)}
      </Box>
      {/* Only show this show discount line if !clientfacing */}
      {discount > 0 && (
        <Box className={classes.dataRow}>
          <Typography className={classes.blueTitles}>DISCOUNT</Typography>
          <Typography className={classes.font}>
            {discount > 0 ? "- $ " + formatNumberWithCommas(discount) : "-"}
          </Typography>
        </Box>
      )}

      {!client && (
        <Box className={classes.dataRow}>
          <Typography className={classes.blueTitles}>Expenses</Typography>
          <Typography className={classes.font}>
            {data.payAble > 0
              ? " $ " + formatNumberWithCommas(data.payAble)
              : "0"}
          </Typography>
        </Box>
      )}

      <Box className={classes.dataRow}>
        <Typography className={classes.blueTitles}>PAID</Typography>
        <Typography className={classes.font}>
          {"- $ " + formatNumberWithCommas(data.paid)}
        </Typography>
      </Box>

      <Divider />
      <Box className={classes.dataRow}>
        <Typography className={classes.blueTitles}>BALANCE</Typography>
        <Typography className={classes.font}>
          ${" "}
          {combined
            ? formatNumberWithCommas(data.remaining)
            : formatNumberWithCommas(data.payAble - data.paid - discount)}
        </Typography>
      </Box>
      {/* ADD DISCOUNT BUTTON */}
      {addDiscount && (
        <Box display="flex" justifyContent="flex-end">
          <Button
            className={classes.addButton}
            onClick={handleCreateDiscount}
            disabled={isDisabled}
          >
            <AddIcon style={{ fontSize: "10px" }} />
            <Typography variant="body1">
              {discount < 1 ? "Add Discount" : "Edit Discount"}
            </Typography>
          </Button>
        </Box>
      )}
    </Box>
  )
}

ExpenseTableTotal.propTypes = {
  data: PropTypes.object,
  combined: PropTypes.bool, // only passed as true when additional & regular exp to be combined - ex: Bill Approval Admin
  addDiscount: PropTypes.bool, // only passed on admin pages - not on client
  discount: PropTypes.number,
  soloData: PropTypes.object, //only comes in on Solo
  setSoloData: PropTypes.func, //only comes in on Solo
}

export default ExpenseTableTotal
